import { NgModule } from '@angular/core';
import { AuthenticationRouting } from './authentication-routing';

@NgModule({
  imports: [AuthenticationRouting]
})
export class AuthenticationModule {}
